import React from 'react';

export { default as reducer } from './FleetsOverviewReducer';

export const FleetsOverview = React.lazy(() => import('./FleetsOverviewContainer'));
